export const RATING_BADGE_TEXTS = {
  empty: '–',
} as const;
